import { Paragraph } from "../Components/Paragraph";
import Button from "../Components/Button";
import { Link } from "react-router-dom"

function HelpSupport() {
    return (
      <div className="mx-auto flex max-w-xl flex-col items-center justify-center">
        <h1 className="mb-6 text-center text-2xl font-bold">Help & Support</h1>
        <Paragraph className="text-center">
          We're here to help! Whether you have questions about the Encircled Personal Journey or
          need assistance with your plan, we've got you covered.
        </Paragraph>

        <div className="w-full space-y-6">
          {/* Email Support */}
          <div className="rounded-lg bg-neutral-50 p-6">
            <div className="mb-3 flex items-center gap-3">
              <i className="fa-solid fa-envelope text-2xl text-brand"></i>
              <h2 className="text-lg font-bold">Contact Us</h2>
            </div>
            <Paragraph className="mb-3">
              Have a question or need help? Send us an email and we'll get back to you as soon as
              possible.
            </Paragraph>
            <a
              href="mailto:info@encircled.org"
              className="font-semibold text-brand hover:underline"
            >
              info@encircled.org
            </a>
          </div>

          {/* FAQ */}
          <div className="rounded-lg bg-neutral-50 p-6">
            <div className="mb-3 flex items-center gap-3">
              <i className="fa-solid fa-circle-question text-2xl text-brand"></i>
              <h2 className="text-lg font-bold">Frequently Asked Questions</h2>
            </div>
            <Paragraph className="mb-3">
              Find answers to common questions about Encircled Personal Journey, the plan process,
              and more.
            </Paragraph>
            <Link
              to={"/faq"}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-semibold text-brand hover:underline"
            >
              Visit FAQ Page
              <i className="fa-solid fa-arrow-up-right-from-square text-sm"></i>
            </Link>
          </div>

          {/* Resources */}
          <div className="rounded-lg bg-neutral-50 p-6">
            <div className="mb-3 flex items-center gap-3">
              <i className="fa-solid fa-book text-2xl text-brand"></i>
              <h2 className="text-lg font-bold">Resources & Guides</h2>
            </div>
            <Paragraph className="mb-3">
              Access helpful resources, guides, and materials to support the Encircled Personal
              Journey.
            </Paragraph>
            <a
              href="/resources"
              className="inline-flex items-center gap-2 font-semibold text-brand hover:underline"
            >
              Browse Resources
              <i className="fa-solid fa-arrow-right text-sm"></i>
            </a>
          </div>

          {/* Add to Home Screen */}
          <div className="rounded-lg bg-neutral-50 p-6">
            <div className="mb-3 flex items-center gap-3">
              <i className="fa-solid fa-mobile-screen text-2xl text-brand"></i>
              <h2 className="text-lg font-bold">Add to Home Screen</h2>
            </div>
            <Paragraph className="mb-4">
              Access Encircled quickly by adding it to your phone&apos;s home screen — no app store
              required.
            </Paragraph>

            <div className="mb-4">
              <h3 className="mb-2 font-semibold">Safari</h3>
              <ol className="list-inside list-decimal space-y-1 text-sm text-gray-700">
                <li>
                  Tap the <strong>Share</strong> button{" "}
                  <i className="fa-solid fa-arrow-up-from-bracket text-xs"></i> at the bottom of
                  the screen
                </li>
                <li>
                  Scroll down and tap <strong>Add to Home Screen</strong>
                </li>
                <li>
                  Tap <strong>Add</strong> in the top right
                </li>
              </ol>
            </div>

            <div className="mb-4">
              <h3 className="mb-2 font-semibold">Chrome</h3>
              <ol className="list-inside list-decimal space-y-1 text-sm text-gray-700">
                <li>
                  Tap the <strong>three-dot menu</strong>{" "}
                  <i className="fa-solid fa-ellipsis-vertical text-xs"></i> at the top right
                </li>
                <li>
                  Tap <strong>Add to Home screen</strong>
                </li>
                <li>
                  Tap <strong>Add</strong>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    )
}

export default HelpSupport;